import { requestConstants } from '../constants/request.constants';

export function requests(state = {}, action) {
  switch (action.type) {
    case requestConstants.CREATE_REQUEST:
    case requestConstants.FETCH_REQUEST:    
    case requestConstants.GET_REQUEST:
    case requestConstants.REMOVE_REQUEST:    
      return {
        ...state,
        loading: true
      };   
    case requestConstants.APPROVE_REQUEST:
    case requestConstants.REJECT_REQUEST:
    return {
      ...state,
      approveLoading: true
    }     
    case requestConstants.CREATE_SUCCESS:
    case requestConstants.GET_SUCCESS:
    return {
      ...state,
      item: action.request,
      loading: false
    }    
    case requestConstants.FETCH_SUCCESS:      
      return {
        ...state,
        ...action.requests,
        loading: false
      };
    case requestConstants.APPROVE_SUCCESS:
    case requestConstants.REJECT_SUCCESS:
    return {
      ...state,
      approveLoading: false
    }     
    case requestConstants.CREATE_FAILURE:
    case requestConstants.FETCH_FAILURE:
    case requestConstants.GET_FAILURE:
    case requestConstants.REMOVE_FAILURE:
    case requestConstants.UPDATE_FAILURE:
    case requestConstants.APPROVE_FAILURE:
    case requestConstants.REJECT_FAILURE:            
      return {
        ...state,
        error: action.error,
        loading: false
      };   
    default:
      return state
  }
}
